export default "__VITE_ASSET__CPvzWNgg__"